/**
 * Important note!
 * Some style properties isn't same as Figma design 'cuz there are many variations in Figma and idk what should i do!
 */

import { type ChangeEvent, type KeyboardEvent, useState } from "react";
import { Counter } from "./secondary";

type Props = {
  count: number;
  onCountChange: (count: number) => void;
  maxCount?: number;
  variant: "primary" | "secondary";
};

export const ItemQuantityCounter = (props: Props) => {
  const { count, onCountChange, maxCount = 1000, variant = "primary" } = props;

  if (count < 0) {
    throw new Error('"count" prop must be greater than or equal to 0.');
  }

  if (maxCount <= 0) {
    throw new Error('"maxCount" prop must be greater than 0.');
  }

  if (count > maxCount) {
    throw new Error(
      '"maxCount" prop must be greater than or equal to "count" prop.',
    );
  }

  const [isEditing, setIsEditing] = useState<boolean>(false);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const value = parseInt(event.target.value, 10);
    if (!isNaN(value) && value >= 0 && value <= maxCount) {
      onCountChange(value);
    }
  };

  const handleBlur = (): void => setIsEditing(false);

  const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === "Enter") {
      setIsEditing(false);
    }
  };

  const handleIncrement = (): void => {
    if (count < maxCount) {
      onCountChange(count + 1);
    }
  };

  const handleDecrement = (): void => {
    if (count > 0) {
      onCountChange(count - 1);
    }
  };

  const handleClean = (): void => {
    onCountChange(0);
  };

  const args = {
    count,
    maxCount,
    isEditing,
    setIsEditing,
    handleBlur,
    handleClean,
    handleDecrement,
    handleIncrement,
    handleInputChange,
    handleKeyPress,
  };

  return <Counter {...args} />;
};
